import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IMerchant } from "@interfaces";

import { RootState } from ".";
import { theme } from "@utils";

const initialState: IMerchant = {
  name: "",
  themeColor: "",
  subColor: "",
  logoUrl: "",
  store_id: "",
  trafficSourceId: "",
};
const colorThemes = theme.colors.colorThemes;

const merchant = createSlice({
  name: "theme",
  initialState,
  reducers: {
    setMainColor: (state, action: PayloadAction<string>) => {
      state.themeColor = action.payload;
      colorThemes.forEach((color) => {
        if (action.payload === color.main) {
          state.subColor = color.sub;
        }
      });
    },
    setMerchant: (state, action: PayloadAction<IMerchant>) => {
      state = action.payload;
      return action.payload;
    },
    setTrafficSourceId: (state, action: PayloadAction<string>) => {
      state.trafficSourceId = action.payload;
    },
    resetMerchant: () => {
      return initialState;
    },
  },
});

export const selectMerchant = (state: RootState) => state.merchant;

export const { setMainColor, setMerchant, setTrafficSourceId, resetMerchant } = merchant.actions;

export default merchant.reducer;
